var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg02RiskMitigation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 190",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-10 {\n        fill: #f6f6e0;\n      }\n\n      .cls-11 {\n        fill: #00be84;\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-13 {\n        fill: #aaa883;\n      }\n\n      .cls-14 {\n        fill: #f99316;\n      }\n\n      .cls-15 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-16 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-17 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-18 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-19 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-20 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-21 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-22 {\n        fill: #fff;\n      }\n\n      .cls-23 {\n        fill: #ddd7b6;\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-25 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-26 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-27 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-28 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-29 {\n        fill: #0562e8;\n      }\n\n      .cls-30 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 25.95,
    y: 9.09,
    width: 211.16,
    height: 181.58
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.96,28.03c0-1.54.21-3.07.64-4.55-11.98-1.94-24.08-3.1-36.21-3.49-11.76.37-23.48,1.48-35.09,3.31.45,1.54.68,3.13.68,4.73,0,9.46-7.99,17.21-18.19,17.67,1.24,15.63,5.61,36.89,10.74,48.36,8.52,19.02,37.93,35.73,41.92,38.68,3.99-2.95,33.36-19.66,41.92-38.68,5.15-11.5,9.5-32.81,10.74-48.44-9.68-.98-17.15-8.48-17.15-17.59Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1943.84,
    y1: -186.43,
    x2: 1944,
    y2: -186.43,
    gradientTransform: "translate(2207566.56 -23015957.81) rotate(90) scale(11840.5 -11840.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3dba85",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1de885",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1940.32,
    y1: -187.75,
    x2: 1940.48,
    y2: -187.75,
    gradientTransform: "translate(-1278162.2 -123605.66) scale(658.76 -658.76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3dba85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1de885"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.39,28.85c-8.36.22-16.7.89-24.99,1.99-1.31,9.85-7.97,18.16-17.29,21.6.92,7.11,2.21,14.17,3.87,21.14,1.31,5.85,3.12,11.57,5.41,17.11,5.67,12.65,23.95,25.23,33,31.18V28.85Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1943.82,
    y1: -186.45,
    x2: 1943.98,
    y2: -186.45,
    gradientTransform: "translate(2207763.65 -23015701.13) rotate(90) scale(11840.5 -11840.5)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1942.29,
    y1: -181.66,
    x2: 1942.45,
    y2: -181.66,
    gradientTransform: "translate(-96036.96 1027821.56) rotate(-90) scale(529.12 -529.12)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M130.58,31c-8.67-1.19-17.4-1.91-26.15-2.16v92.99c9.1-5.99,27.31-18.52,32.98-31.16,2.29-5.54,4.1-11.26,5.41-17.11,1.72-7.12,3.05-14.33,3.99-21.6-8.75-3.62-14.92-11.6-16.23-20.98Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1943.86,
    y1: -186.47,
    x2: 1944.02,
    y2: -186.47,
    gradientTransform: "translate(2208028.6 -23016242.74) rotate(90) scale(11840.5 -11840.5)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1946.26,
    y1: -191.64,
    x2: 1946.42,
    y2: -191.64,
    gradientTransform: "translate(94292.25 -956318) rotate(90) scale(491.38 -491.38)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.94,191.74h30.6c-1.72-4.97-5.75-8.8-10.8-10.26-1.47-.43-2.99-.64-4.51-.64-6.9,0-13.04,4.38-15.29,10.9Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1943.79,
    y1: -186.44,
    x2: 1943.95,
    y2: -186.44,
    gradientTransform: "translate(2207611.3 -23015269.61) rotate(90) scale(11840.5 -11840.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d35400",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb62d",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1931.76,
    y1: -188.39,
    x2: 1931.92,
    y2: -188.39,
    gradientTransform: "translate(-370052.61 -35908.56) scale(191.59 -191.59)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d35400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb62d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M187.07,191.74h53.1c-.55-14.26-12.28-25.54-26.55-25.54s-26,11.27-26.55,25.54Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1943.79,
    y1: -186.5,
    x2: 1943.95,
    y2: -186.5,
    gradientTransform: "translate(2208413.54 -23015314.97) rotate(90) scale(11840.5 -11840.5)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1934.81,
    y1: -187.6,
    x2: 1934.97,
    y2: -187.6,
    gradientTransform: "translate(-643030.51 -62186.97) scale(332.44 -332.44)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.19,191.74h53.08c-.67-14.17-12.36-25.31-26.54-25.31s-25.87,11.14-26.54,25.31Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1943.79,
    y1: -186.45,
    x2: 1943.95,
    y2: -186.45,
    gradientTransform: "translate(2207719.28 -23015314.97) rotate(90) scale(11840.5 -11840.5)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1936.57,
    y1: -187.6,
    x2: 1936.73,
    y2: -187.6,
    gradientTransform: "translate(-643482.04 -62163.71) scale(332.32 -332.32)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.93,183.08c0,2.9.23,5.8.7,8.66h105.26c4.53-27.5-12.89-53.85-39.97-60.47-27.08-6.62-54.69,8.73-63.36,35.22-1.75,5.35-2.64,10.95-2.64,16.59Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1943.8,
    y1: -186.46,
    x2: 1943.96,
    y2: -186.46,
    gradientTransform: "translate(2207886.75 -23015429.44) rotate(90) scale(11840.5 -11840.5)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1939.97,
    y1: -187.06,
    x2: 1940.13,
    y2: -187.06,
    gradientTransform: "translate(-1295334.81 -124753.41) scale(667.76 -667.76)",
    xlinkHref: "#linear-gradient-8"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: -1.64,
    y: -1.2,
    width: 303.28,
    height: 192.41
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.53,
    y: 9.09,
    width: 181.58,
    height: 181.58
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M234.32,178.87l-13.07,1.2V35.21s13.07,5.63,13.07,5.63v138.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 72.41,
    y: 35.21,
    width: 148.83,
    height: 145.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 143.44,
    y: 47.17,
    width: 42.62,
    height: 7.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 196.39,
    y: 47.17,
    width: 16.49,
    height: 7.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 164.74,
    y: 61.76,
    width: 48.13,
    height: 7.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 154.95,
    y: 76.37,
    width: 42.62,
    height: 7.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 206.47,
    y: 76.37,
    width: 6.67,
    height: 7.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 143.44,
    y: 90.96,
    width: 32.84,
    height: 7.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 182.76,
    y: 90.96,
    width: 30.12,
    height: 7.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 143.44,
    y: 107.65,
    width: 42.62,
    height: 7.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 196.39,
    y: 107.65,
    width: 16.49,
    height: 7.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 83.09,
    y: 136.85,
    width: 42.62,
    height: 7.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 136.05,
    y: 136.85,
    width: 16.49,
    height: 7.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 83.09,
    y: 150.26,
    width: 16.49,
    height: 7.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 164.74,
    y: 122.24,
    width: 48.13,
    height: 7.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 191.38,
    y: 136.85,
    width: 21.76,
    height: 7.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 182.76,
    y: 151.44,
    width: 30.12,
    height: 7.52
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 51.79,
    y: 19.98,
    width: 105.32,
    height: 112.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 51.79,
    y: 19.98,
    width: 105.32,
    height: 112.76
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M139.96,28.03c0-1.54.21-3.07.64-4.55-11.98-1.94-24.08-3.1-36.21-3.49-11.76.37-23.48,1.48-35.09,3.32.45,1.54.68,3.13.68,4.73,0,9.46-7.99,17.21-18.19,17.67,1.24,15.63,5.61,36.89,10.74,48.36,8.52,19.02,37.93,35.73,41.92,38.68,3.99-2.95,33.36-19.66,41.92-38.68,5.15-11.5,9.5-32.81,10.74-48.44-9.68-.98-17.15-8.48-17.15-17.59Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 62.11,
    y: 28.85,
    width: 42.28,
    height: 93.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 62.11,
    y: 28.85,
    width: 42.28,
    height: 93.01
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 104.43,
    y: 28.85,
    width: 42.38,
    height: 92.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 104.43,
    y: 28.85,
    width: 42.38,
    height: 92.99
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M93.55,64.34l-16.65,14.39,27.39,22.26,27.67-54.23-29.5,34.25-8.9-16.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M93.55,57.97l-16.65,14.39,27.39,22.26,27.67-54.23-29.5,34.23-8.9-16.65Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 58.94,
    y: 180.84,
    width: 30.6,
    height: 10.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 58.94,
    y: 180.84,
    width: 30.6,
    height: 10.9
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 187.07,
    y: 166.2,
    width: 53.1,
    height: 25.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 187.07,
    y: 166.2,
    width: 53.1,
    height: 25.54
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 76.19,
    y: 166.44,
    width: 53.08,
    height: 25.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 76.19,
    y: 166.44,
    width: 53.08,
    height: 25.31
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 102.92,
    y: 124.65,
    width: 110.49,
    height: 67.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 102.92,
    y: 124.65,
    width: 110.49,
    height: 67.09
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02RiskMitigation);
export default __webpack_public_path__ + "static/media/02 Risk Mitigation.485b42b095898837390e39f8428cb6cc.svg";
export { ForwardRef as ReactComponent };